export default function Numpy_ArrayJoin() {
  return <div>Numpy_ArrayJoin Component</div>;
}
